import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { formatPriceString } from 'site-modules/shared/utils/price-utils';
import { PopoverItem } from 'site-modules/shared/components/popover-item/popover-item';
import { EditLink } from './edit-link';

export function PriceBreakdownListItem({
  name,
  price,
  tooltipText = null,
  className = null,
  nameClassName = null,
  priceClassName = null,
  isPriceStrikethrough = false,
  hasEditLink = false,
  children = null,
}) {
  const priceValue = typeof price === 'number' ? formatPriceString(price) : price;

  return (
    <li className={classnames('price-breakdown-item', className)}>
      <div className="d-flex justify-content-between">
        <div className={nameClassName}>
          {name}
          {!!tooltipText && (
            <PopoverItem iconClassName="medium text-primary-darker" screenReaderTooltipLabel={name}>
              {tooltipText}
            </PopoverItem>
          )}
          {hasEditLink && <EditLink name={name} />}
        </div>
        <div className={priceClassName}>{isPriceStrikethrough ? <s>{priceValue}</s> : priceValue}</div>
      </div>
      {children}
    </li>
  );
}

PriceBreakdownListItem.propTypes = {
  name: PropTypes.string.isRequired,
  price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  tooltipText: PropTypes.string,
  className: PropTypes.string,
  nameClassName: PropTypes.string,
  priceClassName: PropTypes.string,
  isPriceStrikethrough: PropTypes.bool,
  hasEditLink: PropTypes.bool,
  children: PropTypes.node,
};
